import {isClub, SiteType} from "../js_env";

export class RegularDeliveryJsEnv {
  isLogin: boolean;
  siteType: SiteType;

  constructor(
    isLogin: boolean,
    siteType: SiteType
  ) {
    this.isLogin = isLogin;
    this.siteType = siteType;
  }

  makeRegularDeliveryUrl(catalogItemCode: string, regularDeliveryCatalogItemCode: string): string {
    const BASE_URL = `${window.location.protocol}//${window.location.host}/`;
    const quantitySelector = `[data-regular_delivery_count="${regularDeliveryCatalogItemCode}"]`;
    let quantity = document.querySelector<HTMLInputElement>(quantitySelector)?.value ?? 1;
    const tenOverCountSelector = `[data-regular_delivery_ten_over_count="${regularDeliveryCatalogItemCode}"]`;
    const tenOverCount = document.querySelector<HTMLInputElement>(tenOverCountSelector)?.value ?? 1;
    if (quantity == 10) {
      quantity = tenOverCount;
    }

    if (isClub(this.siteType)) {
      return `${BASE_URL}odr/order/regularOdrFirstProcess/applyRegOdr?ctgItemcd=${catalogItemCode}&qty=${quantity}`;
    }
    if (this.isLogin) {
      return `${BASE_URL}buyer/view/a400/DAE05020.html?regSupId=P00001&regRegularProdCd=${regularDeliveryCatalogItemCode}&regQty=${quantity}&regOrdSts=1`;
    }
    const directUrl = encodeURIComponent(`/buyer/view/a400/DAE05020.html?regSupId=P00001&regRegularProdCd=${regularDeliveryCatalogItemCode}&regQty=${quantity}&regOrdSts=1`);
    return `${BASE_URL}buyer/view/a010/DAA01010.html?directUrl=${directUrl}`;
  }
}
